var _style, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileCars = function SvgCategoryMobileCars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_cars_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_cars_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_cars_svg__st0",
    d: "m13.5 28.8-.7-.3C11.7 28 11 27 11 25.7v-1c0-.6.2-1 .6-1.5l1.7-1.6c1.9-1.9 4.6-2.8 7.3-2.8l3.4.2c.5 0 1 .1 1.4.4l5.3 3c.5.3 1 .4 1.5.6.2 0 .3.1.6.1H34c.7 0 1.3.2 1.9.6l2.1 1.4c.6.3.8 1 .8 1.6v.3c0 .3-.1.8-.4 1l-.3.4c-.3.3-.7.5-1.1.5h-2.4M12 23h19.8M18.5 28.8h10.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "category_mobile_cars_svg__st0",
    cx: 16.1,
    cy: 28.8,
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "category_mobile_cars_svg__st0",
    cx: 32,
    cy: 28.8,
    r: 2.4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "m20.3 19.2.5 7.6h5.8"
  }));
};
export default SvgCategoryMobileCars;